import * as React from 'react'

import { Box, CheckBox, Table } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

export interface HeaderCheckboxProps {
  selected: boolean
  onSelectAll?: (() => void) | null | undefined
  onDeselectAll?: (() => void) | null | undefined
}

const HeaderCheckbox = ({ selected, onSelectAll, onDeselectAll }: HeaderCheckboxProps) => {
  return (
    <Table.HeadCell width={38} paddingX="s16">
      <Box onClick={selected ? onDeselectAll : onSelectAll}>
        <CheckBox checked={selected} />
      </Box>
    </Table.HeadCell>
  )
}

export default observer(HeaderCheckbox)
